import Spacer from './spacer'

Spacer.install = vue => {
  vue.component(Spacer.name, Spacer)
}

export default Spacer
